import { useContext } from 'react'

import { DateLimits } from '../context'

/**
 * @returns {{maxDate: Date, minDate: Date}}
 */
export function useDateLimits() {
  return useContext(DateLimits)
}
